import { ArrowRight, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Card, CardAction, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { navigate } from "@/lib/nav";

export type StatCardProps = {
  title: string;
  icon: LucideIcon;
  /** Ana sayı, çağıranın biçimlediği API değeri. null/undefined = hesap yapılmadı: sayı yerine `empty` cümlesi yazılır, "0" ya da "—" yazılmaz (ui.md §12.6). */
  value?: ReactNode;
  empty?: string;
  description?: ReactNode;
  /** Sayının yanındaki grafik (aria-hidden bileşenler). */
  visual?: ReactNode;
  /** Kartın altındaki bağlantı. */
  link?: { href: string; text: string };
  children?: ReactNode;
};

/** KPI kartı (ui.md §12.6). Kart tıklanabilir yüzey değildir, yalnız alt bağlantı gider. */
export function StatCard({ title, icon: Icon, value, empty, description, visual, link, children }: StatCardProps) {
  const has = value !== null && value !== undefined;
  return (
    <Card data-slot="stat-card" className="h-full gap-0 p-0">
      <CardHeader className="px-4 pt-4">
        <h2 className="text-sm font-medium text-muted-foreground">{title}</h2>
        <CardAction><span aria-hidden="true" className="flex size-9 items-center justify-center rounded-lg bg-primary/10 text-primary"><Icon className="size-4" /></span></CardAction>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col gap-2 px-4 py-3">
        {has ? (
          <div className="flex items-center gap-4">
            {visual}
            <div className="min-w-0">
              <p className="text-3xl font-semibold tabular-nums">{value}</p>
              {description && <p className="text-sm text-muted-foreground">{description}</p>}
            </div>
          </div>
        ) : empty ? <p className="text-sm text-muted-foreground">{empty}</p> : null}
        {children}
      </CardContent>
      {link && (
        <CardFooter className="border-t px-4 py-3">
          <a href={link.href} onClick={(e) => navigate(e, link.href)} className="inline-flex items-center gap-1 rounded-sm text-sm text-primary underline-offset-4 outline-none hover:underline focus-visible:ring-[3px] focus-visible:ring-ring">
            {link.text}<ArrowRight aria-hidden="true" className="size-4" />
          </a>
        </CardFooter>
      )}
    </Card>
  );
}
